// firebase config

export const firebaseConfig = {
  apiKey: "AIzaSyA24vbMYbIKHpFE5Rwp5c28ltyIkbPF1ys",
  authDomain: "solar-scientist.firebaseapp.com",
  databaseURL: "https://solar-scientist-default-rtdb.firebaseio.com",
  projectId: "solar-scientist",
  storageBucket: "solar-scientist.appspot.com",
  messagingSenderId: "55041103705",
  appId: "1:55041103705:web:dcb97466990e034ce65e48",
  measurementId: "G-YRP76Q3W3H"
};